import { configureAuth } from 'react-query-auth';

import {
  loginWithEmailAndPassword,
  registerWithEmailAndPassword,
  LoginCredentialsDTO,
  RegisterCredentialsDTO,
  AuthUser,
  AuthUserStudioCast,
} from '@/features/auth';
import storage from '@/utils/storage';
import { jwtDecode } from "jwt-decode";


async function handleUserResponse(data: AuthUser): Promise<AuthUserStudioCast> {
  const decoded_token = jwtDecode(data.token)
  storage.setToken(JSON.stringify(data));
  storage.setExpiration(decoded_token.exp * 1000);
  return data.result;
}

async function userFn(): Promise<AuthUserStudioCast | null> {
  if (storage.getToken()) {
    const { result } = JSON.parse(storage.getToken());
    return result;
  }
  return null;
}

async function loginFn(data: LoginCredentialsDTO): Promise<AuthUserStudioCast> {
  const response = await loginWithEmailAndPassword(data);
  return handleUserResponse(response);
}

async function registerFn(data: RegisterCredentialsDTO): Promise<AuthUserStudioCast> {
  const response = await registerWithEmailAndPassword(data);
  return handleUserResponse(response);
}

async function logoutFn(): Promise<void> {
  storage.clearToken();
  window.location.assign(window.location.origin as unknown as string);
}

const { useUser, useLogin, useRegister, useLogout, AuthLoader } = configureAuth<
  AuthUserStudioCast | null,
  unknown,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>({
  userFn,
  loginFn,
  registerFn,
  logoutFn,
});

export { AuthLoader };

export function useAuth() {
  const userQuery = useUser();
  const loginMutation = useLogin();
  const logoutMutation = useLogout();
  const registerMutation = useRegister();

  return {
    user: userQuery.data ?? null,
    isLoading: userQuery.isLoading,
    error: userQuery.error,
    login: loginMutation.mutateAsync,
    logout: logoutMutation.mutate,
    register: registerMutation.mutateAsync,
    refetchUser: userQuery.refetch,
  };
}
